<template>
  <div class="row g-2 justify-content-center text-center gap-3 my-5">
    <div class="col-md-10">
      <h3>Finde die zuverlässigsten Zugverbindungen zu Top Reisezielen</h3>
    </div>
    <travel-destination
      class="col-3 p-0"
      description="In die Hauptstadt nach"
      title="Berlin"
      :image="berlinImg"
      :url="{
        path: '/',
        hash: '#search',
        query: { destination: 'Berlin Hbf' }
      }"
    ></travel-destination>
    <travel-destination
      class="col-3 p-0"
      description="Zuverlässige Reise nach"
      title="München"
      :image="münchenImg"
      :url="{
        path: '/',
        hash: '#search',
        query: { destination: 'München Hbf' }
      }"
    ></travel-destination>
    <travel-destination
      class="col-3 p-0"
      description="Mit dem Nahverkehr nach"
      title="Sylt"
      :image="syltImg"
      :url="{
        path: '/',
        hash: '#search',
        query: { destination: 'Westerland(Sylt)', only_regional: true }
      }"
    ></travel-destination>
    <travel-destination
      class="col-3 p-0"
      description="An den Bodensee nach"
      title="Lindau"
      :image="lindauImg"
      :url="{
        path: '/',
        hash: '#search',
        query: { destination: 'Lindau-Reutin' }
      }"
    ></travel-destination>
    <travel-destination
      class="col-3 p-0"
      description="In die Hafenstadt nach"
      title="Hamburg"
      :image="hamburgImg"
      :url="{
        path: '/',
        hash: '#search',
        query: { destination: 'Hamburg Hbf' }
      }"
    ></travel-destination>
    <travel-destination
      class="col-3 p-0"
      description="Zuverlässige Verbindungen:"
      title="Tübingen - Köln"
      :image="kölnImg"
      :url="{
        path: '/journey-search-result',
        hash: '#search',
        query: { destination: 'Köln Hbf', start: 'Tübingen Hbf' }
      }"
    ></travel-destination>
  </div>
</template>

<script setup lang="ts">
import travelDestination from '../components/TravelDestination.vue'

import berlinImg from '~/assets/img/berlin.avif'
import münchenImg from '~/assets/img/munchen.avif'
import syltImg from '~/assets/img/sylt.avif'
import lindauImg from '~/assets/img/lindau.avif'
import hamburgImg from '~/assets/img/hamburg.avif'
import kölnImg from '~/assets/img/koln.avif'
</script>
